module.exports = __webpack_public_path__ + "static/fonts/ionicons.2c2ae06.eot";


//////////////////
// WEBPACK FOOTER
// ./~/iview/src/styles/common/iconfont/fonts/ionicons.eot?v=2.0.0
// module id = 190
// module chunks = 34